import { CODE_ENUM } from '@/constants'
import { defaultPayload } from '@/core'
import { ResponseMessage } from '@/types'

// 成功响应
export const resSuccess = <T = any>(data: T): ResponseMessage<T> => {
  return {
    ...defaultPayload,
    data,
  }
}

// 失败响应
export const resError = <T = any>(
  data: T,
  message = '',
  code = CODE_ENUM.ERROR
): ResponseMessage<T> => {
  return {
    code,
    message,
    data,
  }
}
